/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type SettlementLineDtoType = typeof SettlementLineDtoType[keyof typeof SettlementLineDtoType];


export const SettlementLineDtoType = {
  owed_to_agency: 'owed_to_agency',
  owed_to_player: 'owed_to_player',
  deduction: 'deduction',
} as const;
